var Backbone = require('backbone'),
	IndexModel = require('./indexModel');

module.exports = Backbone.Collection.extend({

    model: IndexModel,
    /*
    * Note: if forDocumentName provided for the intention of a file download,
    * the file name needs to be sanitized afterward by the caller.
    * */
    firstIndexValue: function(forDocumentName) {

        if ( this.length < 1 )
            return null;

        var firstModel = this.at(0);

        return forDocumentName
            ? firstModel.getShortenedDisplayValue()
            : firstModel.getMultiLineDisplayValue();

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/model/indexCollection.js
 ** module id = 401
 ** module chunks = 0
 **/